import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardContent, CardFooter, CardTitle, CardDescription } from '@/components/ui/card';
import InfoSection from './InfoSection';

interface LoginCardProps {
  children: React.ReactNode;
  verificationMessage?: string;
  errorMessage?: string;
}

const LoginCard = ({ children, verificationMessage, errorMessage }: LoginCardProps) => {
  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-md mx-auto pt-8 px-4">
        <Card className="w-full">
          <CardHeader className="space-y-1">
            <div className="flex justify-center mb-4">
              <img 
                src="/lovable-uploads/ddc85206-c911-40ff-878f-a9ba074283b9.png" 
                alt="Coach Vault Logo" 
                className="h-24 w-24 object-contain"
              />
            </div>
            <CardTitle className="text-2xl text-center">Coach Vault</CardTitle>
            <CardDescription className="text-center">
              Enter your credentials to access your account
            </CardDescription>
          </CardHeader>
          <CardContent>
            {children}
          </CardContent>
          <CardFooter className="flex justify-between flex-col space-y-4">
            <div className="w-full text-center space-y-2">
              <p className="text-sm text-muted-foreground">
                Don't have an account?{" "}
                <Link to="/signup" className="text-coaching-primary hover:underline">
                  Sign up
                </Link>
              </p>
              <p className="text-xs text-muted-foreground">
                Forgot your password?{" "}
                <Link to="/reset-password" className="text-coaching-primary hover:underline">
                  Reset Password
                </Link>
              </p>
            </div>
          </CardFooter>
        </Card>
      </div>
      <InfoSection />
    </div>
  );
};

export default LoginCard;
